import React, {useEffect, useState} from 'react'
import {Row, Col, Image} from 'react-bootstrap';
import {firebase} from "../../firebase/firebaseConfig";
import EditModal from "./EditModal";

import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';

export default function UserIntro(props) {
  const [profileURL, setProfileURL] = useState(`profilePictures/default.jpg`);
  const [open, setOpen] = useState(false);
  const storage = firebase.storage();
  const user = firebase.auth().currentUser;
  const [isAuthor, setIsAuthor] = useState(user && user.uid === props.authorID);
  const [notification, setNotification] = useState(null);

  useEffect(() => setIsAuthor(user && user.uid === props.authorID), [user]);

  useEffect(() => {
    const pathRef = storage.ref(`profilePictures/${props.authorID}/profile.jpg`)
    pathRef.getDownloadURL()
    .then((url) => setProfileURL(url))
    .catch(() => storage.ref(profileURL).getDownloadURL().then((url) => setProfileURL(url)) );
  }, [])
  
  return (
    <>
    {open && <EditModal open={open} setOpen={setOpen} authorID={props.authorID} setNotification={setNotification}/>}
    <Row className="user-intro mx-0 my-2">
      {isAuthor && <Col xs={12} className="text-right edit-button"><button className="btn btn-link" onClick={() => setOpen(true)}>✏️ Edit Profile</button></Col>}
      <Col lg={4} md={4} sm={12}><Image src={profileURL} roundedCircle/></Col>
      <Col lg={8} md={8} sm={12} className="text-left mt-3">
        <h3 className="author-name">{props.authorName}</h3>
        {props.bio && <p className="author-bio">{props.bio}</p>}
        {props.location && <p className="author-location">{props.location}</p>}
        {props.contacts && <a className="mr-3" href={props.contacts.website} target="_blank" rel="noopener noreferrer">{props.contacts.website.split("https://")}</a>}
      </Col>
    </Row>

    <Snackbar 
        open={Boolean(notification)} 
        autoHideDuration={3000} 
        onClose={() => setNotification(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        key={'topcenter'}
        >
        {Boolean(notification) && <MuiAlert elevation={6} variant="filled" severity={notification === 'success' ? 'success' : 'error' }>
          {notification === 'success' ? "Profile updated! Refresh to see changes." : "Oops... that didn't work. Try again later?"}
        </MuiAlert>}
      </Snackbar>
    </>
  )
}
